import {
    SET_SVC_REQUEST,
    SET_SVC_REQUEST_RAW
} from '../actions/actionTypes';
import template from 'url-template';
import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';
import awsHeader from '../helpers/awsAuth';
import lambdaBaseApi from '../apis/lambda';


const SvcRequestUrl = template.parse('/servicecalls');


export const setSvcRequestItem = payload => ({
    type: SET_SVC_REQUEST,
    payload
});

export const setSvcRequestRaw = payload => ({
    type: SET_SVC_REQUEST_RAW,
    payload
});

export const clearSvcRequest = () => ({
    type:    SET_SVC_REQUEST_RAW,
    payload: {}
});

export const createSvcRequest  = ( body, options = {}) => async (dispatch) => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.post(
            SvcRequestUrl.expand({
                ...options
            }),
            body,
            header
        );

        dispatch(enqueueSnackbar('Service Request Created Successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};
